import type React from "react";
import { useState } from "react";

import { faNoteMedical } from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useTranslation } from "react-i18next";

import { usePrepareCareEventOptions } from "routes/patients/utils/usePrepareCareEventOptions";
import { Tooltip } from "shared/atoms/Tooltip";

import { ButtonText, StyledDropDownButton } from "./components/PatientHeaderDropdownStyles";
import { useNoteCreation } from "./hooks/useNoteCreation";

interface PatientHeaderInfoAddNoteButtonProps {
  customDropdownStyling?: string;
}

export const PatientHeaderInfoAddNoteButton: React.FC<PatientHeaderInfoAddNoteButtonProps> = ({
  customDropdownStyling,
}) => {
  const { t } = useTranslation();
  const { createNote } = useNoteCreation();
  const [tooltipMessage, setTooltipMessage] = useState<string | null>(null);

  const handleCreateNote = async (type: string): Promise<void> => {
    const { success, error } = await createNote(type);

    if (!success) {
      setTooltipMessage(error ? t("errors.generic") : t("messages.disabled_chat_note"));
    }
  };

  const options = usePrepareCareEventOptions({ createNote: handleCreateNote });

  return (
    <Tooltip
      title={tooltipMessage ?? ""}
      open={!!tooltipMessage}
      onClose={() => setTooltipMessage(null)}
      arrow
      placement="bottom"
      disableHoverListener
      disableFocusListener
    >
      <div>
        <StyledDropDownButton
          id="new-care-event-button"
          options={options}
          dropdownOrigin="right"
          dataTestId="new-care-event-button"
          customDropdownStyling={customDropdownStyling}
        >
          <FontAwesomeIcon icon={faNoteMedical} style={{ height: "16px", width: "16px" }} />
          <ButtonText>{t("messages.new_note")}</ButtonText>
        </StyledDropDownButton>
      </div>
    </Tooltip>
  );
};
